import { render } from "./CertificateFromLinks.vue?vue&type=template&id=a49d70fa&scoped=true"
import script from "./CertificateFromLinks.vue?vue&type=script&lang=js"
export * from "./CertificateFromLinks.vue?vue&type=script&lang=js"

import "./CertificateFromLinks.vue?vue&type=style&index=0&id=a49d70fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49d70fa"]])

export default __exports__